import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const AnalyticsPdfTooltip = ({ children, text, placement = 'top' }) => (
  <OverlayTrigger placement={placement} overlay={<Tooltip>{text}</Tooltip>}>
    {children}
  </OverlayTrigger>
)

export default AnalyticsPdfTooltip
